import type { FullParcel } from '@coig/apm-api';
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonImg } from '@ionic/react';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { packageManagmentServices } from '../../services/packageManagmentServices';
import '../packagesList/package/Package.css';
import './RecivedPackage.css';

const recivedPackage: React.FC<FullParcel> = ({ status, id, receiver, parcelName, size, parcelDeposited, registrationTime, statusModificationTime }) => {
  const [updatedStatus, setUpdatedStatus] = useState<FullParcel['status']>();
  if (updatedStatus !== status){
    setUpdatedStatus(status);
  }
  const parcel: FullParcel = {
    id: id as any,
    status: updatedStatus || status,
    receiver,
    parcelName,
    size,
    parcelDeposited,
    registrationTime,
    statusModificationTime,
  };
  const history = useHistory();
  return (
    <IonCard className={updatedStatus?.toLowerCase().includes('ready') ? 'ready' : 'done'}>
      <IonCardHeader>
        <h2>Parcel: Wien Mitte Landstraße</h2>
        <h2>ID: {id}</h2>
      </IonCardHeader>
      <IonCardContent>
        <div>
          <p>Recipient:</p>
          <h1>{receiver?.name} {receiver?.surname}</h1>
        </div>
        <div>
          <p>Name:</p>
          <h1>{parcelName}</h1>
        </div>
      </IonCardContent>
      <div className='state-bar'>
        <div className="state-bar-left">
          <span>State:</span>
          <h3>{updatedStatus === 'RECEIVED' ? 'Taken out' : 'Locker open'}</h3>
        </div>
      </div>
      <div className='put-package'>
        <h4>Availble options for package</h4>
        <div className='block-buttons'>
          <IonButton hidden={updatedStatus === 'RECEIVED'} color='warning' onClick={async () => {
            const packageState = (await packageManagmentServices.openLocker(parcel))!.status;
            navigator.vibrate(500);
            setUpdatedStatus(packageState);
          }}>Reopen<br/> locker<br/> now
          </IonButton>
          <IonButton className='call-service' href="tel:+48123456789">
            Call<br/> customer<br/> service
          </IonButton>
          {updatedStatus === 'RECEIVED' ?
            <IonButton color='success' onClick={() => history.goBack() }>
            Thanks<br/> thats<br/> all
            </IonButton>
            : <> </>}
        </div>
      </div>
    </IonCard>
  );
};

export { recivedPackage as RecivedPackage };
